import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pageview } from "@/lib/tracking/analytics";

/**
 * Sends a page view on every navigation after the first (the first is sent
 * when the analytics finish loading). A no-op without consent.
 */
export function AnalyticsPageviews() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    pageview();
  }, [pathname]);
  return null;
}
